import { FORM_ENTITY_BUSINESSES } from "routes";
import { createSemaphore } from "../utils";

export class EntityBusinessService {
	constructor(api) {
		this.api = api;
		this.businessesByEntity = {};
		this.businessesSemaphore = createSemaphore(1);
	}

	async getBusinessesForEntity(formId, entityId, { forceReload = false } = {}) {
		const cacheKey = this.getCacheKey(formId, entityId);

		if(forceReload || this.businessesByEntity[cacheKey] === undefined) {
			this.businessesByEntity[cacheKey] = this.fetchBusinessesForEntity(formId, entityId, cacheKey);
		}

		return await this.businessesByEntity[cacheKey];
	}

	async fetchBusinessesForEntity(formId, entityId, cacheKey) {
		try {
			const loadBusinesses = () => this.api.get(FORM_ENTITY_BUSINESSES(formId, entityId));
			return await this.businessesSemaphore.run(loadBusinesses);
		}
		catch(err) {
			delete this.businessesByEntity[cacheKey];
			throw err;
		}
	}

	invalidateBusinessesForEntity(formId, entityId) {
		if(formId === undefined || entityId === undefined) {
			this.businessesByEntity = {};
			return;
		}

		delete this.businessesByEntity[this.getCacheKey(formId, entityId)];
	}

	getCacheKey(formId, entityId) {
		return `${formId}:${entityId}`;
	}
}

export default angular
	.module("vesl.services.entity-business-service", [])
	.service("entityBusinessService", EntityBusinessService).name;
